import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/store-cost-kinds/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const storeCostKinds = {
  getAll: apiPathFunc(pathBase),
} as const;
